<template>
  <v-card class="mx-auto container" flat>
    <div v-if="header" class="secondary--text pa-0">
      <p class="subtitle-1 mb-1">{{ header }}</p>
    </div>
    <v-divider class="mb-3"></v-divider>
    <base-form-generator :schema="schema" v-model="form" />
  </v-card>
</template>

<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
export default {
  name: 'FormEsai',
  components: { BaseFormGenerator },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    schema() {
      let forms = [];
      for (const item of this.items) {
        forms.push({
          type: 'VTextarea',
          name: item.id,
          label: `${item.kode}. ${item.pertanyaan}`,
          labelClass: item.class || 'subtitle-1 font-weight-medium',
          placeholder: `Lengkapi isian Esai dengan minimal ${item.min_kata} kata ${
            !item.maks_kata || item.maks_kata === Infinity ? '' : `dan maksimal ${item.maks_kata} kata`
          }`,
          hint:
            !item.maks_kata || item.maks_kata === Infinity
              ? `Isian esai minimal ${item.min_kata} kata`
              : `Isian esai ${item.min_kata} - ${item.maks_kata} kata`,
          counter: item?.maks_kata ?? Infinity,
          counterValue: (v) => this.$wordCount(v),
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
          autoGrow: true,
          required: false,
          // rules: { required: false, minChar: item.min || 10, maxChar: item.max || 100 },
        });
      }

      return forms;
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },
    initForm(value) {
      const formulir = [...this.schema];
      for (const f of formulir) {
        this.$set(this.form, f.name, (value && value[f.name]) || '');
      }
    },
    mutate() {
      this.$emit('mutate');
    },
  },
  watch: {
    initValue: 'initForm',
    form: {
      handler() {
        this.mutate();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
